// Only prepare offscreen content, avoiding a visible -> hidden flash on page load.
const initializeSectionReveals = () => {
  const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (motion.matches || !window.IntersectionObserver) return;

  const selector = ".site-eyebrow, .site-title, .location-card, .section-4__media, .section-4__text, .section-1__text, .section-2__text, .section-7__text, .location-cards__description, .accordion-item, .btn";
  const pending = new Set();
  const reveal = (element, delay = 0) => {
    element.style.setProperty("--reveal-delay", `${delay}ms`);
    element.classList.remove("section-reveal--pending");
    pending.delete(element);
    observer.unobserve(element);
  };
  const observer = new IntersectionObserver((entries) => {
    let index = 0;
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      reveal(entry.target, motion.matches ? 0 : Math.min(index++ * 65, 195));
    }
  }, { threshold: 0, rootMargin: "0px 0px 40px 0px" });

  document.querySelectorAll("#main-content .section").forEach((section) => {
    section.querySelectorAll(selector).forEach((element) => {
      if (element.parentElement.closest(selector)) return;
      // Do not animate initially visible content, including restored scroll positions.
      if (element.getBoundingClientRect().top <= window.innerHeight + 40) return;
      element.classList.add("section-reveal", "section-reveal--pending");
      pending.add(element);
      observer.observe(element);
    });
  });

  motion.addEventListener("change", () => {
    if (!motion.matches) return;
    pending.forEach((element) => reveal(element));
    observer.disconnect();
  });
  document.addEventListener("focusin", (event) => {
    pending.forEach((element) => {
      if (element.contains(event.target)) {
        element.classList.remove("section-reveal");
        reveal(element);
      }
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeSectionReveals, { once: true });
} else {
  initializeSectionReveals();
}
